import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeCheckoutForm from "../components/StripeCheckoutForm";
import { isEmpty } from "../functions/isEmpty";
import { useNavigate } from "react-router";

export default function Checkout({
  isMobile,
  apiURL,
  authToken,
  order,
  setReload,
  reload,
  setActiveOrderRedirect,
  companyData,
}) {
  const navigate = useNavigate();
  const [clientSecret, setClientSecret] = useState(null);
  const [payment_id, setPayment_id] = useState(null);
  const [orderData, setOrderData] = useState({});

  const shoppingCard = order?.shoppingCard || [];

  useEffect(() => {
    if (isEmpty(authToken)) {
      setActiveOrderRedirect(true);
      navigate("/login");
    }

    if (!isEmpty(order)) {
      setOrderData(order);
    } else {
      navigate("/");
    }
  }, [order]);

  useEffect(async () => {
    if (!isEmpty(order)) {
      let shoppingCard = [{ id: order.service_id }];

      const resa = await fetch(`${apiURL}/api/api/clientsecret.php`, {
        method: "POST",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          shoppingCard: shoppingCard,
        }),
      });

      await resa.text().then((value) => saveSecret(value));
    }
  }, [order]);

  const saveSecret = (data) => {
    setClientSecret(JSON.parse(data).clientSecret);
    setPayment_id(JSON.parse(data).payment_id);
  };

  const stripePromiseTest = loadStripe(
    "pk_test_51Nc4qsGgDkyV2jPHM1mp2JE4ojdrFAi044x1mnUdamHfjCXnogAjdgVqK7sLBW3T5XfPUC6PR88A8xRp4ysQoBcL00XpxBwwez"
  );

  const stripePromiseLive = loadStripe(
    "pk_live_51Nc4qsGgDkyV2jPHjblUn0cXBDbSJk2mszCH8wWb1qKYdMSniNHC8yQV8c5lni4EzTG24omdCRQ2tM3sMIeelFIV00AXmWB0AN"
  );

  // Warte, bis das clientSecret geladen ist
  if (!clientSecret) {
    return <div>Lade...</div>;
  }

  return (
    <div className="home">
      <Elements stripe={stripePromiseLive} options={{ clientSecret }}>
        <StripeCheckoutForm
          isMobile={isMobile}
          apiURL={apiURL}
          authToken={authToken}
          reload={reload}
          setReload={setReload}
          order={order}
          setActiveOrderRedirect={setActiveOrderRedirect}
          orderData={orderData}
          setOrderData={setOrderData}
          companyData={companyData}
          payment_id={payment_id}
        />
      </Elements>
    </div>
  );
}
